<template>
  <div id="app">
    <szr/>
  </div>
</template>

<script>
import szr from './components/szr.vue'
export default {
  name: 'App',
  components: {
    szr
  }
}
</script>

<style>
html,body{
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
}
#app {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
